module.exports = __webpack_public_path__ + "static/media/taxGuard.0c2a62b0.jpg";